import { createSelector } from "reselect";
const selector = (state) => state.date;

export default createSelector([selector], (data) => data);